<template>
  <div id="app">
    <keep-alive>
      <router-view name="header"></router-view>
      <!--命名视图 路由控制是否显示返回的头部-->
    </keep-alive>
    <div class="container">
      <transition name="trans">
        <keep-alive include="userInfo,memberAward,addMember">
          <!--这些组件(name)名称 页面缓存-->
          <router-view/>
        </keep-alive>
      </transition>
    </div>
    <loading v-if="loadingStatus" v-cloak></loading>
  </div>
</template>

<script>
import loading from './components/common/loading.vue'
export default {
  name: 'App',
  components: { loading },
  computed: {
    loadingStatus: function () {
      return this.$store.state.loading.isLoading
    }
  }
}
</script>

<style lang="less" rel="stylesheet/less">
/*无scope 样式可供全局使用*/
body {
  #app {
    font-family: "Avenir", Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    .container {
      position: absolute;
      width: 100%;
      height: calc(100% - 1rem);
      overflow: hidden;
    }
  }
}

.tc {
  text-align: center;
}

.tr {
  text-align: right;
}

.mr20 {
  margin-right: 20px;
}

.mr10 {
  margin-right: 10px;
}

.bb {
  position: relative;
  border-bottom: none !important;
}

.bb:after {
  content: " ";
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 1px;
  background-color: #d5d5d6;
  -webkit-transform-origin: 0 0;
  -ms-transform-origin: 0 0;
  transform-origin: 0 0;
  -webkit-transform: scaleY(0.5);
  -ms-transform: scaleY(0.5);
  transform: scaleY(0.5);
}

.br {
  position: relative;
  border-right: none !important;
}

.br:before {
  content: " ";
  position: absolute;
  top: 0;
  right: 0;
  width: 1px;
  height: 100%;
  background-color: #d5d5d6;
  -webkit-transform-origin: 0 0;
  -ms-transform-origin: 0 0;
  transform-origin: 0 0;
  -webkit-transform: scaleX(0.5);
  -ms-transform: scaleX(0.5);
  transform: scaleX(0.5);
}
.bt {
  position: relative;
  border-right: none !important;
}

.bt:before {
  content: " ";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 1px;
  background-color: #d5d5d6;
  -webkit-transform-origin: 0 0;
  -ms-transform-origin: 0 0;
  transform-origin: 0 0;
  -webkit-transform: scaleY(0.5);
  -ms-transform: scaleY(0.5);
  transform: scaleY(0.5);
}

.pd10 {
  padding: 10px;
}

.pdlr10 {
  padding: 0 10px;
}

.mb5 {
  margin-bottom: 5px;
}

.overEll {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.time {
  color: #999;
}

.hd {
  background: #f8f8f8;
  position: relative;
  border-bottom: none !important;
}

.hd:after {
  content: " ";
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 1px;
  background-color: #d5d5d6;
  -webkit-transform-origin: 0 0;
  -ms-transform-origin: 0 0;
  transform-origin: 0 0;
  -webkit-transform: scaleY(0.5);
  -ms-transform: scaleY(0.5);
  transform: scaleY(0.5);
}

.tip {
  color: orangered;
}

.red {
  color: red;
  font-size: 0.28rem;
}

.amColor {
  color: orangered;
}

.ali {
  background: #00a6ff;
}

.wechat {
  background: #35a740;
}

.success {
  color: #35a740;
}

.waiting {
  color: orange;
}

.failure {
  color: red;
}

.header {
  height: 1rem;
  background:linear-gradient(to right , #707be4 , #5458b7);
  /*background: linear-gradient(150deg, #33F6F6 0%, #31aeb3 22%, #087e82 50%, #31aeb3 80%, #33F6F6 100%);*/
  color: #fff;
}
.headerTitle{
  font-size:14px;
  color:#fff;
}

.closeBtn {
  position: relative;
  width: 1rem;
  height: 1rem;
}
.nullData {
  height: 5rem;
  line-height: 5rem;
  text-align: center;
}
.more {
  position: absolute;
  top: 50%;
  right: 0;
  -webkit-transform: translate3d(0, -50%, 0);
  transform: translate3d(0, -50%, 0);
}

.closeBtn:after {
  content: "";
  width: 0.4rem;
  height: 1px;
  display: block;
  background: #999;
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%) rotate(-45deg);
  transform: translate(-50%, -50%) rotate(-45deg);
}

.closeBtn:before {
  content: "";
  width: 0.4rem;
  display: block;
  height: 1px;
  background: #999;
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%) rotate(45deg);
  transform: translate(-50%, -50%) rotate(45deg);
}

.trueIcon {
  width: 0.3rem;
  height: 0.3rem;
  position: relative;
}

.trueIcon:after {
  content: "";
  width: 0.3rem;
  height: 1px;
  display: block;
  background: #31aeb3;
  position: absolute;
  top: 50%;
  left: 81%;
  -webkit-transform: translate(-50%, -50%) rotate(-45deg);
  transform: translate(-50%, -50%) rotate(-45deg);
}

.trueIcon:before {
  content: "";
  width: 0.15rem;
  display: block;
  height: 1px;
  background: #31aeb3;
  position: absolute;
  top: 64%;
  left: 32%;
  -webkit-transform: translate(-50%, -50%) rotate(45deg);
  transform: translate(-50%, -50%) rotate(45deg);
}

.button {
  min-width: 1.5rem;
  border-radius: 0.6rem;
  color: #fff;
  /*background:#409EFF ;*/
  /*background: linear-gradient(150deg, #33F6F6 0%, #31aeb3 22%, #087e82 50%, #31aeb3 80%, #33F6F6 100%);*/
  background:linear-gradient(to right , #707be4 , #5458b7);
  padding: 4px 10px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.confirmButton {
  min-width: 1.5rem;
  color: #fff !important;
  /*background:#409EFF ;*/
  border-radius: 0 0 3px 0;
  /*background: linear-gradient(150deg, #33F6F6 0%, #31aeb3 22%, #087e82 50%, #31aeb3 80%, #33F6F6 100%);*/
  background: linear-gradient(to right, #707be4, #5458b7);
  padding: 2px 10px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.nullData {
  height: 5rem;
  line-height: 5rem;
  text-align: center;
}

//上拉下拉
.rotate {
  -webkit-transform: rotate(90deg);
  transform: rotate(90deg);
  transition: all 0.2s;
}

.mint-spinner-snake {
  -webkit-animation: mint-spinner-rotate 0.8s infinite linear;
  animation: mint-spinner-rotate 0.8s infinite linear;
  border: 2px solid transparent;
  border-radius: 50%;
}

.swiper-pagination {
  position: absolute;
  text-align: right !important;
  padding-right: 10px !important;
}

@keyframes mint-spinner-rotate {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }

  100% {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn);
  }
}

//组件切换
/*平移*/
.trans-enter-active,
.trans-leave-active {
  /*在两个active阶段用transition*/
  transition: all 0.3s cubic-bezier(0.55, 0, 0.1, 1);
  position: absolute;
  width: 100%;
}

.trans-enter {
  -webkit-transform: translate3d(-80px, 0, 0);
  transform: translate3d(-80px, 0, 0);
  opacity: 0;
}

.trans-leave-active {
  -webkit-transform: translate3d(-80px, 0, 0);
  transform: translate3d(-80px, 0, 0);
  opacity: 0;
}

/*淡入淡出*/
.fade-enter-active,
.fade-leave-active {
  /*在两个active阶段用transition*/
  transition: all 0.35s cubic-bezier(0.55, 0, 0.1, 1);
}

.fade-enter {
  /*在-enter;-leave-active 阶段写动画效果*/
  opacity: 0;
}

.fade-leave-active {
  /**/
  opacity: 0;
}

/*从下到上*/
.transUp-enter-active,
.fade-leave-active {
  /*在两个active阶段用transition*/
  transition: all 0.35s cubic-bezier(0.55, 0, 0.1, 1);
  position: absolute;
  width: 100%;
}

.transUp-enter {
  /*在-enter;-leave-active 阶段写动画效果*/
  -webkit-transform: translate3d(0, 100px, 0);
  transform: translate3d(0, 100px, 0);
  opacity: 0;
}

.transUp-leave-active {
  /**/
  -webkit-transform: translate3d(0, 100px, 0);
  transform: translate3d(0, 100px, 0);
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/App.vue